import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-6 px-6 border-t" style={{ background: '#080810', borderColor: 'rgba(0,255,229,0.15)' }}>
      <p className="text-center text-xs tracking-wide font-mono" style={{ color: 'rgba(0,255,229,0.6)', fontFamily: "'JetBrains Mono', monospace" }}>
        &copy; 2026 RecallCore. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
